/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import {
  STORE,
  DELETE,
  CREATE,
  UPDATE
} from './mutation-types'

const logError = (type) => {}

export default {
  [STORE] (state, { prefix, data, catalog }) {
    const dict = prefix ? state[prefix] : state
    if (!dict) {
      return
    }
    dict[catalog] = data
  },
  [DELETE] (state, { type, data }) {
    let catList = state[type]

    if (!catList) {
      logError(type)
      return
    }

    let index = catList.indexOf(data)
    catList.splice(index, 1)
  },
  [UPDATE] (state, { type, data, old_data: oldData }) {
    let catList = state[type]
    if (!catList) {
      logError(type)
      return
    }

    let index = catList.indexOf(oldData)

    if (index !== -1) {
      catList.splice(index, 1, data)
    } 
  },
  [CREATE] (state, { type, data }) {
    let catList = state[type]

    if (!catList) {
      logError(type)
      return
    }

    catList.push(data)
  }
}
